<template lang="pug">
b-table.payments-table.mb-4(head-variant="light" borderless :items="productos" :fields="fieldsRepuestos")
  template(#cell(producto)="data")
    .producto-cell
      p.codigo-text COD: {{ data.item.codigo }}
      h5.producto-text {{ data.item.producto }}
</template>

<script>
export default {
  name: 'TabPaymentsTable',
  props: {
    productos: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      fieldsRepuestos: [
        { key: 'producto', label: 'Producto' },
        { key: 'cantidad', label: 'Cantidad' },
        { key: 'precio_unitario', label: 'Precio Unitario' },
        { key: 'descuento', label: 'Descuento Total' },
        { key: 'precio_total', label: 'Total' },
      ],
    }
  },
}
</script>

<style lang="scss" scoped>
.codigo-text {
  font-size: 10px;
  color: #999;
  margin: 0;
  font-weight: 400;
}

.producto-text {
  font-size: 14px;
  color: #23201C;
  margin: 0;
}

.producto-cell {
  text-align: left;
}
</style>

<style lang="scss">
.payments-table.table td {
  padding: 0.15rem 0.75rem !important;
  text-align: left;
  vertical-align: middle;
  color: #23201C;
}

.payments-table.table td:first-child,
.payments-table.table th:first-child {
  text-align: left;
}

.payments-table.table td:last-child,
.payments-table.table th:last-child {
  text-align: right;
}

.payments-table.table th {
  text-align: left;
  vertical-align: middle;
  color: #23201C;
}
</style>
